export const businessTypeConfigQuery = `
  query BusinessTypeConfig {
    businessTypeConfig {
      code
      businessType
      sellingMode
      baseUnit
    }
  }
`;

export const supportedBusinessTypesQuery = `
  query SupportedBusinessTypes {
    supportedBusinessTypes {
      code
      stage
      featureFlags
      businessTypes {
        key
        enabled
      }
    }
  }
`;
